enum BulletinFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

interface BulletinRecipient {
  userId?: string;
  email?: string;
}

interface BulletinRequest {
  enabled: boolean;
  frequency: BulletinFrequency;
  sendTime: string;
  sendDayOfWeek?: string;
  sendDayOfMonth?: number;
  recipients: BulletinRecipient[];
  timezone: string;
}

type BulletinResponse = BulletinRequest;

export type { BulletinRecipient, BulletinRequest, BulletinResponse };
export { BulletinFrequency };
